import { memo } from "react";
import * as Icons from "lucide-react";
import { tileTheme } from "../../lib/tileColor";
import { CATEGORIES } from "../../lib/constants";
import { catLabel } from "../../lib/i18n";

export const CategoryTabs = memo(function CategoryTabs({ category, lang, colorFor, onPick }) {
  return (
    <div className="flex gap-2 overflow-x-auto md:flex-wrap no-scrollbar pb-2">
      {CATEGORIES.map((c) => {
        const Icon = Icons[c.icon] || Icons.PawPrint;
        const active = category === c.id;
        const th = active ? tileTheme(colorFor(c.id)) : null;
        return (
          <button
            key={c.id}
            onClick={() => onPick(c.id)}
            data-testid={`filter-category-${c.id}`}
            style={th ? { ...th.style, borderColor: th.style.backgroundColor } : undefined}
            className={`flex items-center gap-2 whitespace-nowrap px-4 py-2 rounded-full text-sm font-semibold transition-colors border ${
              th ? th.label : active ? "bg-[#12234A] text-white border-[#12234A]" : "bg-white text-slate-600 border-slate-200 hover:border-[#F5551E]"
            }`}
          >
            <Icon size={16} className={th ? th.icon : active ? "text-[#F5551E]" : ""} /> {catLabel(lang, c.id, c.label)}
          </button>
        );
      })}
    </div>
  );
});

export const CategoryStrip = ({ color, icon, label, description, total }) => {
  const th = tileTheme(color);
  const Icon = Icons[icon] || Icons.PawPrint;
  return (
    <div className="mt-4 rounded-2xl px-6 py-5 flex items-center gap-4 shadow-sm" style={th.style} data-testid="category-color-strip">
      <span className={`h-12 w-12 rounded-xl flex items-center justify-center ${th.iconBg}`}><Icon size={24} className={th.icon} /></span>
      <div className="min-w-0">
        <h1 className={`font-display font-extrabold text-2xl ${th.label}`}>{label}</h1>
        <p className={`text-sm ${th.sub}`}>{description || `${total} listing${total === 1 ? "" : "s"}`}</p>
      </div>
    </div>
  );
};
